<template>
    <div class="modal_third_step modal-backdrop">
        <div class="modal">
          <button type="button"
                  class="btn-close"
                  @click="close"> x
          </button>
          <div class="content">
            <header class="modal-header-question">
                <slot name="header">
                  <h2>{{translate("send_your_request")}} </h2>
                </slot>
            </header>
            <div class="modal-body-question">
                <slot name="body">
                    <div class="question-msg" v-if="getActiveStep == 3">{{translate("question_message")}}
                    </div>
                    <inputs-custom-question :placeholder='translate("desired_pressure")'
                                            data-type="number"
                                            :require=false
                                            name="pressure">
                    </inputs-custom-question>
                    <inputs-custom-question :placeholder='translate("desired_efficiency")'
                                            data-type="number"
                                            :require=false
                                            name="efficiency">
                    </inputs-custom-question>
                    <inputs-custom-question :placeholder='translate("email")'
                                            data-type="email"
                                            :require=true
                                            :regex='/^(([^<>()\[\]\\.,;:\s@]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/'
                                            name="email"
                                            :error-msg='translate("error_msg_empty_email")'
                    >
                    </inputs-custom-question>
                    <inputs-custom-question :placeholder='translate("phone")'
                                            data-type="number"
                                            :require=false
                                            :regex='/[A-Za-z0-9]/'
                                            name="phone"
                                            :error-msg='translate("error_msg_empty_phone")'>
                    </inputs-custom-question>
                    <area-custom-question name="request_content">
                    </area-custom-question>
                    <rodo-input name="RODO"/>
                    <div ref="dropzone" class="dropzone-wrapper">
                        <div class="dropzone-custom-content" v-if="dropzoneEmpty">
                            <p class="dropzone-text" v-if="dropzoneEmpty">{{translate('add_attachment')}}</p>
                            <p class="file-size-placeholder">Max. 5MB (.png, .jpg, .jpeg, .pdf, .txt)</p>
                        </div>
                    </div>

                </slot>
            </div>
            <footer class="modal-footer-question">
                <slot name="footer">
                    <div class="navi-btns">
                        <button @click.prevent="tryApprove" class="summary-btn" :class="{'disabled': fileInProgress}">
                            {{translate("send")}}
                        </button>
                    </div>
                </slot>
            </footer>
          </div>
        </div>
    </div>
</template>

<script>
    import InputsCustomQuestion from "./question_inputs/InputsCustomQuestion";
    import AreaCustomQuestion from "./question_inputs/AreaCustomQuestion";
    import RodoInput from "../../register_inputs/rodoInput";
    import Dropzone from 'dropzone'
    import Uniqid from 'uniqid';

    export default {
        name: "ThirdStepModalMail",
        components: {RodoInput, AreaCustomQuestion, InputsCustomQuestion},
        props: ['target'],
        data() {
            return {
                value: '',
                isIncorrect: false,
                inputData: [],
                dropzoneEmpty: true,
                fileInProgress: false,
                returnedFileCode: null
            }
        },
        methods: {
            tryApprove(e) {
                this.$emit('getValidateData');

                if (this.isSendingDisabled) {

                    console.error('Uzupełnij wymagane pola');

                    e.preventDefault();

                    return;

                } else {
                    this.send(e)
                }
            },

            send() {
                this.$apiController.sendMaterialRequest(this.getFormData())
                    .then((res) => {
                        if (res.data === true) {
                            this.$notifications.add('notification', this.translate('notification_success'), this.translate('request_sent_success'));
                            this.close();
                        } else {
                            this.$notifications.add('error', this.translate('notification_error'), this.translate('request_sent_fail'));
                        }
                    });
            },

            isValidationDataValid() {

                if (this.inputData.length > 0) {

                    return !this.inputData.some(item => item.isIncorect === true)

                } else {
                    return false;
                }
            },

            getFormData() {
                let form = new FormData();
                for (let key of this.inputData) {
                    form.append(key.inputName, key.value);
                }
                form.append('target', this.target);
                if (this.returnedFileCode) {
                    form.append('attachment', this.returnedFileCode);
                }
                return form;
            },

            removeFileFromServer(file) {
                let form = new FormData();

                form.append('file', file.name);
                form.append('code', this.returnedFileCode);

                this.$apiController.removeFileFromServer(form)
                    .then((res) => {
                        if (res.data === true) {
                            // console.log('removed');
                        } else {
                            console.error('failed removing file from server');
                        }
                    });
            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            close() {
                this.$emit('close');
            },
        },

        computed: {
            isSendingDisabled() {

                return (
                    !this.isValidationDataValid()
                );
            },

            getActiveStep() {
                return this.$store.state.activeConfigurationStep;
            },
        },

        mounted() {
            this.returnedFileCode = JSON.parse(JSON.stringify(Uniqid()));

            let _this = this;
            Dropzone.prototype.defaultOptions.dictRemoveFile = this.translate('remove');
            Dropzone.prototype.defaultOptions.dictCancelUpload = this.translate('cancel');
            Dropzone.prototype.defaultOptions.dictCancelUploadConfirmation = this.translate('confirm');

            new Dropzone(this.$refs.dropzone, {
                url: this.$apiController.fileUploadDropzoneUrl(),
                paramName: 'file',
                parallelChunkUploads: false,
                retryChunks: false,
                addRemoveLinks: true,
                maxFiles: 5,
                maxFilesize: 5 * 1048576,
                createImageThumbnails: false,
                chunkSize: 1024 * 1024,
                init: function () {
                    this.on("removedfile", function (file) {
                        _this.dropzoneEmpty = this.files.length <= 0;
                        _this.removeFileFromServer(file);
                    });

                    this.on("sending", function(file, xhr, formData) {
                        formData.append('code', _this.returnedFileCode)
                    });

                    this.on("addedfile", function (event) {
                        _this.fileInProgress = true;
                        while (this.files.length > this.options.maxFiles) {
                            this.removeFile(this.files[0]);
                        }

                        _this.dropzoneEmpty = this.files.length <= 0;
                    });

                    this.on("maxfilesexceeded", function (file) {
                        this.removeAllFiles();
                        this.addFile(file);
                    });
                },
                success: function (file, response) {
                    response = JSON.parse(response);
                    _this.fileInProgress = false;
                    if (response.status === 'error') {
                        this.removeAllFiles();
                        if (response.message) {
                            const translatableErrorCodes = ['non_valid_file_ext', 'file_size_exceeded'];

                            if (translatableErrorCodes.indexOf(response.message) !== -1) {
                                _this.$notifications.add(_this.$notifications.TYPES.WARNING, _this.translate('file_upload'), _this.translate(response.message));
                            } else {
                                _this.$notifications.add(_this.$notifications.TYPES.ERROR, _this.translate('file_upload'), _this.translate('unidentified_internal_error'));
                            }
                        }
                    } else {
                        if (response.data && response.data.code) {
                            // _this.returnedFileCode = response.data.code;
                        }
                    }
                }
            });

            this.$on('validateData', (d) => {

                if (!this.inputData.some(item => item.inputName === d.inputName)) {

                    this.inputData.push(d)

                } else if (this.inputData.some(item => item.inputName === d.inputName)) {

                    this.inputData.forEach((element) => {

                        if (element.inputName === d.inputName) {
                            element.inputName = d.inputName;
                            element.isIncorect = d.isIncorect;
                            element.value = d.value ? d.value : '';
                        }
                    })
                }
            });
        },

        beforeDestroy() {
            this.$off('validateData');
        }
    }
</script>
